import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SetFocusModule } from '../../../directives/set-focus/set-focus.module';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { ActionLabelModule } from '../../molecules/action-label/action-label.module';
import { DropdownComponent } from './dropdown.component';

@NgModule({
  declarations: [DropdownComponent],
  imports: [
    CommonModule,
    ErrorTooltipModule,
    ActionLabelModule,
    SetFocusModule
  ],
  exports: [DropdownComponent]
})
export class DropdownModule {}
